export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    /**
     * Re-emits an event to the global event bus if a mapping exists in eventMap.
     * This method should be called by the parent component's event listeners.
     * @param {string} eventName The name of the event emitted by the child component.
     * @param {*} payload The payload of the event.
     */
    reemitToEventBus(eventName, payload) {
      if (this.options?.eventMap && this.options?.eventMap[eventName]) {
        this.$eventBus.$emit(this.options?.eventMap[eventName], payload);
      }
    },
  },
};
